import { render } from "./TheLangSelector.vue?vue&type=template&id=81a11cde"
import script from "./TheLangSelector.vue?vue&type=script&lang=ts"
export * from "./TheLangSelector.vue?vue&type=script&lang=ts"
script.render = render

export default script